export const plans = {
  0: 'Legacy',
  1: 'Starter',
  2: 'Pro',
  3: 'Master',
};

export default { plans };
